module.exports = __webpack_public_path__ + "media/images/partners/thailand-pct-94abbd51c27c7da2dac652d2212e942f.png";